module.exports = __webpack_public_path__ + "media/images/download-android-btn-fafebfb4238a3255313e807c0f033106.png";